import styled from 'styled-components'

export const CarouselContainer = styled.div``
